export default __webpack_public_path__ + "static/media/pinpo-corp-strike.dc223c17.svg";